<template>
  <div>
    <div class="step-item" v-for="(item,index) in cookSteps" :key="item.code">
      <h4 class="mb16">{{$t('步骤') + ' ' + (index+1)}}</h4>
      <div class="mb16">
        <div class="flex mb16">
          <span>{{ `${$t('步骤类型')}：` }}</span>
          <dict-select flag="STEP_TYPE" :value="item.stepType" disabled />
        </div>

        <div class="mb16" style="display: flex">
          <span style="flex-shrink: 0">{{ `${$t('操作说明')}：` }}</span>
          <span>{{ item.instruction || "" }}</span>
        </div>

        <div class="food-box">
          <div class="food-item" v-for="food in item.cookFoodBeans" :key="food.code">
            <preview-img :size="40" :img-url="food.foodPhoto || ''" />
            <div class="food-content" style="margin-left: 12px">
              <span>{{ food.foodName || "" }}</span>
              <span>{{ food.foodWeight || "" }}</span>
              <span>{{ food.tips || "" }}</span>
            </div>
          </div>
        </div>

      </div>

      <div class="mb16 tip-box">
        <div style="display: flex" class="mb16">
          <span style="flex-shrink: 0">{{ `${$t('小贴士')}：` }}</span>
          <span>{{ item.tips || "" }}</span>
        </div>
        <div class="tip-cover-list">
          <preview-img :size="60" :img-url="item.tipsPhoto" />
        </div>
      </div>

      <div class="flex" v-if="item.stepType === 'time'">
        <span>{{ `${$t('智能计时器')}：` }}</span>
        <span style="font-weight: bold">{{ item.duration || "" }}</span>
      </div>

    </div>
  </div>
</template>

<script>
import {request} from "@/config/request";
import DictSelect from "@/components/dict/DictSelect";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

// 根据阿拉伯数字返回对应的中文数字
function getChineseNumber(num) {
  const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  return chineseNumbers[num];
}

export default {
  name: "RecipeStep3",
  components: {PreviewImg, DictSelect},
  data() {
    return {
      cookSteps: [],
    }
  },
  activated() {
    this.handleLoadList();
  },
  methods: {
    async handleLoadList() {
      try {
       const res = await request(this.$api.cookStep.list, {cookbookNum: this.recipeCode, onPage: false});
       this.cookSteps = res.cookSteps.map(item => {
         item.stepNumName = this.$t(getChineseNumber(item.whichStep));
         return item;
       });
        console.log("cookeList",this.cookSteps)
      }catch(e) {
         console.log(e);
      }
    },
  },
  computed: {
    recipeCode() {
      return this.$store.state.recipeDetail?.num;
    }
  }
}
</script>

<style scoped>

.step-item {
  width: 500px;
  border-radius: 10px;
  background: #f6f6f6;
  box-sizing: border-box;
  padding: 16px;
  margin-bottom: 30px;
}

.food-item {
  display: flex;
  margin-bottom: 16px;
}

.food-cover {
  width: 60px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 16px;
}

.food-content {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  font-size: 14px;
}


.tip-box {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;
}

.tip-cover-list {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

</style>
